import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(timezone);
dayjs.extend(utc);
import type { PageLoad } from "./$types";

export const load: PageLoad = async ({ fetch, data, depends, url }) => {
  let supabase = null;
  let session = null;
  const bypass = url.searchParams.get("bypass") === "true";
  const langPicker = url.searchParams.get("langs") === "true";

  let disabled = false;
  let disabledType = null;
  let disabledMessage = null;

  const config = data.formEmbed.config as Config;

  if (
    config.restrictToCountries && data.test === false && data.countryCode &&
    data.screenshotHTML === ""
  ) {
    const countries = config.countries;
    if (!countries.includes(data.countryCode)) {
      disabled = true;
      disabledType = "country";
      disabledMessage = null;
    }
  }

  if (
    config.disableAfterDate && data.screenshotHTML === "" &&
    data.test === false && dayjs(config.disableDate).isValid()
  ) {
    const date = dayjs.tz(config.disableDate, "UTC");
    if (date.isBefore(dayjs.tz(dayjs(), "UTC").utc())) {
      disabled = true;
      disabledType = "date";
      disabledMessage = config.disableDateMessage ?? null;
    }
  }

  if (
    data.screenshotHTML === "" &&
    data.test === false && data.formEmbed.config.disabled
  ) {
    disabled = true;
    disabledType = "config";
    disabledMessage = data.formEmbed.config.disabledMessage ?? null;
  }

  if (bypass) {
    disabled = false;
  }

  if (!data.session) {
    return {
      formEmbed: data.formEmbed,
      formLanguages: data.formLanguages,
      formLanguage: data.formLanguage,
      bot: data.bot,
      requestUrl: data.requestUrl,
      translate: data.translate,
      langs: langPicker,
      plan: data.plan,
      countryCode: data.countryCode,
      visitorInfo: data.visitorInfo,
      device: data.device,
      iframe: data.iframe,
      popup: data.popup,
      record: data.record,
      cache: data.cache,
      seamless: data.seamless,
      session: null,
      supabase: null,
      fromCache: data.fromCache,
      disabled,
      disabledType,
      disabledMessage,
      screenshotHTML: data.screenshotHTML,
      bypass,
    };
  }

  depends("supabase:auth");

  const Default = await import("$lib/auth/supabaseBrowserClient");

  supabase = Default.createBrowserClient(data.session!, fetch, true);

  const get_user = await supabase.auth.getUser();

  if (get_user.data) {
    const get_session = await supabase.auth.getSession();
    session = get_session.data;
  }

  return {
    supabase,
    session: session,
    requestUrl: data.requestUrl,
    bot: data.bot,
    translate: data.translate,
    iframe: data.iframe,
    popup: data.popup,
    record: data.record,
    cache: data.cache,
    seamless: data.seamless,
    formEmbed: data.formEmbed,
    formLanguages: data.formLanguages,
    formLanguage: data.formLanguage,
    langs: langPicker,
    plan: data.plan,
    countryCode: data.countryCode,
    visitorInfo: data.visitorInfo,
    device: data.device,
    test: data.test,
    fromCache: data.fromCache,
    disabled,
    disabledType,
    disabledMessage,
    screenshotHTML: data.screenshotHTML,
    bypass,
  };
};
